module.exports = __webpack_public_path__ + "static/media/popup_img.ee35b6a6.png";